module.exports = __webpack_public_path__ + "img/icon-close2-black.2d5f7acf.svg";